import { useContext } from 'react';
import { Context } from './Provider';
function useLogger() {
    var context = useContext(Context);
    return context;
}
export default useLogger;
//# sourceMappingURL=useLogger.js.map